module.exports = __webpack_public_path__ + "img/Event5.4b1f0d64.jpg";